module.exports = __webpack_public_path__ + "img/pnud_logo_claro.e22f47d7.png";